export const EVENTS = {
    // common events
    LOCALIZATION_START: 'localisationStart',
    LOCALIZATION_FINISH: 'localisationFinish',
    START_ORDER: 'start_order',
    SELECT_ORDER_TYPE: 'selectOrderType',
    TYPED_ADDRESS_MANUALLY: 'typed_address_manually',
    CLICKED_LOCATION_ICON: 'clicked_location_icon',
    SHARED_LOCATION_ON_MAP: 'shared_location_on_map',
    CLICKED_ON_START_MY_ORDER: 'clicked_on_start_my_order',

    // edit events
    EDIT_ADDRESS: 'edit_address',
    VIEW_HOME_PAGE_MENU: 'view_home_page_menu',
    CHANGE_ORDER_TYPE: 'change_order_type',
    CHANGE_DELIVERY_ADDRESS: 'change_delivery_address',
    CHANGE_STORE: 'change_store',

    // saved addresses evemts
    SAVED_ADDRESSES: 'saved_addresses', 
    ENTER_ADDRESS_MANUALLY: 'enter_address_manually',
    ADD_NEW_ADDRESS: 'add_new_address',
    DELETE_ADDRESS: 'delete_address',
    LOCATION_TYPE: 'location_type',
}